//import './mobileNavigation.plugin';
//import './dropdown.plugin';
//import './stickyHeader.plugin';
import 'ant-design-vue/dist/antd.css';
import './accordion.plugin';
import './sortHighlighter.plugin';
import './heroCarousel.plugin';
import './preloader.plugin';
import { isIndianaVisitor, applyWeightLossMarketingRestrictions } from './heroGeoRestriction';

// Geo-based weight-loss restrictions (Indiana)
(function () {
    function applyRestrictions() {
        if (isIndianaVisitor()) {
            if (window.location.pathname.toLowerCase().includes('semaglutide-and-tirzepatide')) {
                window.location.href = '/';
                return;
            }
            applyWeightLossMarketingRestrictions();
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', applyRestrictions);
    } else {
        applyRestrictions();
    }

    if (!localStorage.getItem('state')) {
        fetch('/api/geo')
            .then(function (res) {
                if (!res.ok) throw new Error('geo failed');
                return res.json();
            })
            .then(function (data) {
                var state = (data.region || '').trim();
                if (state) localStorage.setItem('state', state);
                var regionCode = (data.region_code || '').trim();
                if (regionCode) localStorage.setItem('stateCode', regionCode);
                var countryCode = (data.country_code || '').trim();
                if (countryCode) localStorage.setItem('countryCode', countryCode);
                applyRestrictions();
            })
            .catch(function () {});
    }
})();
import Vue from 'vue';
import Antd from 'ant-design-vue';
import Product from './Product.vue';
import LoginCta from './LoginCta.vue';
import CartCount from './CartCount.vue';
import Details from './Details.vue';
import PhotoManager from './PhotoManager.vue';
import Conversation from './Conversation.vue';
import CompanyConversation from './CompanyConversation.vue';
import PatientConsultations from './PatientConsultations.vue';
import MessageWatcher from './MessageWatcher.vue';
import StateOrderSelection from './StateOrderSelection.vue';
import NotesInput from './NotesInput.vue';
import Products from './Products.vue';
import WeightProducts from './WeightProducts.vue';
import CreateSleepPrescriptions from './CreateSleepPrescriptions.vue'
import PhoneField from './PhoneField.vue';
import TrtPlanSelector from './TrtPlanSelector.vue';
import CouponCodeField from './CouponCodeField.vue';
import PrescriberCouponCodeField from './PrescriberCouponCodeField.vue';
import RefillFrequencySetter from './RefillFrequencySetter.vue';
import PrescriptionCanceler from './PrescriptionCanceler.vue';
import ResumeRequests from './ResumeRequests.vue';
import MyResumeRequests from './MyResumeRequests.vue';
import CampaignEffectsManager from './CampaignEffectsManager.vue';
import CampaignEffect from './CampaignEffect.vue';
import OfferManager from './OfferManager.vue';
import OfferManagerModal from './OfferManagerModal.vue';
import ConfirmationModal from './ConfirmationModal.vue';
import conditioner from 'offhand-conditioner';
import creditCardType from 'credit-card-type';
import CodeBrowser from './CodeBrowser.vue';
import MediaManager from './MediaManager.vue';
import AllConversation from './AllConversation.vue';
import swal from 'sweetalert';
import fancybox from '@fancyapps/fancybox';
import 'es6-promise/auto';
import $, { each } from 'jquery';
import Inputmask from "inputmask";
import Flickity from 'flickity';
import { Splide } from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import AntdDatePicker from './AntdDatePicker.vue'
import LogsDatePicker from './LogsDatePicker.vue'
import CreateConsultation from './CreateConsultation.vue'
import HighestBmiQuestion from './HighestBmiQuestion.vue';
import HighestDashboardBmiQuestion from './HighestDashboardBmiQuestion.vue';
import CreateConsultationForDerma from './CreateConsultationForDerma.vue';
import CreateConsultationForMentalHealth from './CreateConsultationForMentalHealth.vue'
import CreateConsultationForMensTrt from './CreateConsultationForMensTrt.vue'
import ExportField from './ExportField.vue'
import UpdateExcelPassword from './UpdateExcelPassword.vue'
import AddOrderSetButton from './AddOrderSetButton.vue'
import AcneAnimations from './AcneAnimations.vue'
import AdminDevToolsModal from './AdminDevToolsModal.vue'
import MedicalUpdateAnswersModal from './MedicalUpdateAnswersModal.vue'

import 'select2/dist/css/select2.css';
import 'select2';

require('formdata-polyfill');

window.$ = $;
window.ccType = creditCardType;

/**
 * Prescription set action feedback, shown inline next to the "Order set" heading.
 * Dismisses on the close button or after `timeout` ms, whichever comes first.
 */
window.showSigToast = function (element, content, options) {
    if (!element) {
        return;
    }

    const settings = Object.assign({ isError: false, timeout: 5000 }, options || {});
    const html = content == null ? '' : String(content);

    clearTimeout(element._sigToastTimer);
    element.innerHTML = '';
    element.classList.add('sig-toast');
    element.classList.toggle('-error', !!settings.isError);

    const text = document.createElement('span');
    text.className = 'sig-toast--text';
    text.innerHTML = html;

    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'sig-toast--close';
    close.setAttribute('aria-label', 'Dismiss');
    close.innerHTML = '&times;';

    const hide = function () {
        clearTimeout(element._sigToastTimer);
        element.classList.remove('-visible');
        element.innerHTML = '';
    };

    close.addEventListener('click', hide);

    element.appendChild(text);
    element.appendChild(close);
    element.style.display = '';
    element.classList.add('-visible');

    if (settings.timeout) {
        element._sigToastTimer = setTimeout(hide, settings.timeout);
    }
};

window.handlePrescriptionSetActionResponse = function (data, toastElement) {
    if (data && data.action === 'medical_update_review' && data.mualItem && window.medicalUpdateAnswersModal) {
        window.medicalUpdateAnswersModal.openWithItem(data.mualItem, { confirmFirst: true });
        return;
    }

    window.showSigToast(toastElement, data && data.message, { isError: data && data.result === false });
};

Vue.component('v-product', Product);
Vue.component('v-login-cta', LoginCta);
Vue.component('v-photo-manager', PhotoManager);
Vue.component('v-cart-count', CartCount);
Vue.component('v-details', Details);
Vue.component('v-conversation', Conversation);
Vue.component('v-company-conversation', CompanyConversation);
Vue.component('v-patient-consultations', PatientConsultations);
Vue.component('v-message-watcher', MessageWatcher);
Vue.component('v-state-order-selection', StateOrderSelection);
Vue.component('v-notes-input', NotesInput);
Vue.component('v-coupon-code', CouponCodeField);
Vue.component('v-prescriber-coupon-code', PrescriberCouponCodeField);
Vue.component('v-products', Products);
Vue.component('v-weight-products', WeightProducts);
Vue.component('v-create-sleep-prescriptions', CreateSleepPrescriptions);
Vue.component('v-phone-field', PhoneField);
Vue.component('v-trt-plan-selector', TrtPlanSelector);
Vue.component('v-refill-frequency-setter', RefillFrequencySetter);
Vue.component('v-prescription-canceler', PrescriptionCanceler);
Vue.component('v-resume-requests', ResumeRequests);
Vue.component('v-my-resume-requests', MyResumeRequests);
Vue.component('campaign-effects-manager', CampaignEffectsManager);
Vue.component('campaign-effect', CampaignEffect);
Vue.component('offer-manager', OfferManager);
Vue.component('offer-manager-modal', OfferManagerModal);
Vue.component('confirmation-modal', ConfirmationModal);
Vue.component('code-browser', CodeBrowser);
Vue.component('v-media-manager', MediaManager);
Vue.component('a-picker', AntdDatePicker);
Vue.component('logs-picker', LogsDatePicker);
Vue.component('v-create-consultation', CreateConsultation);
Vue.component('highest-bmi-question', HighestBmiQuestion);
Vue.component('dashboard-bmi-question', HighestDashboardBmiQuestion);
Vue.component('v-create-consultation-for-derma', CreateConsultationForDerma);
Vue.component('v-create-consultation-for-mental-health', CreateConsultationForMentalHealth);
Vue.component('v-create-consultation-for-mens-trt', CreateConsultationForMensTrt);
Vue.component('v-export-field', ExportField);
Vue.component('v-update-excel-password', UpdateExcelPassword);
Vue.component('v-add-order-set-button', AddOrderSetButton);
Vue.component('v-acne-animations', AcneAnimations);
Vue.component('admin-dev-tools-modal', AdminDevToolsModal);
Vue.component('v-medical-update-answers-modal', MedicalUpdateAnswersModal);


Vue.use(Antd);

new Vue({
    el: '#site-container',
    data() {
        return {
            phoneValid: false
        }
    },
    mounted(){
        $('.js-basic-multiple').select2({
            dropdownAutoWidth: true
        });
    }
});

// Use event delegation to handle dynamically created buttons (e.g., from Vue components)
document.addEventListener('click', function(event) {
    const button = event.target.closest('[data-product-id]');

    if (!button || button.hasAttribute('data-next')) {
        return;
    }

    let url = button.href;
    event.preventDefault();


    const productIdStorageKey = button.hasAttribute('data-product-id-weight') ? 'weightProductId' : (
        button.hasAttribute('data-product-id-sleep') ? 'sleepProductId' : (
            button.hasAttribute('data-product-id-sermorelin') ? 'sermorelinProductId' :
                button.hasAttribute('data-product-id-b12') ? 'b12ProductId' :
                    button.hasAttribute('data-product-id-nad') ? 'nadProductId' :
                        button.hasAttribute('data-product-id-retin-a') ? 'retinAProductId' :
                            button.hasAttribute('data-product-id-latisse') ? 'latisseProductId' :
                                button.hasAttribute('data-product-id-hair-loss') ? 'hairLossProductId' :
                                    button.hasAttribute('data-product-id-spironolactone') ? 'spironolactoneProductId' :
                                        button.hasAttribute('data-product-id-doxycycline') ? 'doxycyclineProductId' :
                                            button.hasAttribute('data-product-id-tadalafil') ? 'tadalafilProductId' :
                                                button.hasAttribute('data-product-id-sildenafil') ? 'sildenafilProductId' :
                                                    button.hasAttribute('data-product-id-peptides') ? 'peptidesProductId' :
                                                        button.hasAttribute('data-product-id-mens-trt') ? 'mensTrtProductId' :
                                                            'productId'));
    const productId = button.getAttribute('data-product-id');

    // Always update localStorage with the current product ID from the button
    // This ensures we use the clicked product, not a previously stored one
    localStorage.setItem(productIdStorageKey, productId);

    const shouldExcludeVoucher = button.hasAttribute('data-exclude-voucher');

    const fromBestSellerWlPromo = localStorage.getItem('fromBestSellerWlPromo') === 'true';
    const bestSellerDiscountedPrice = fromBestSellerWlPromo ? localStorage.getItem('discountedPrice') : null;
    const preservedWlRenewalPrice = localStorage.getItem('fromWlRenewalLink') === 'true'
        ? localStorage.getItem('wlRenewalPrice')
        : null;
    const preservedWlRenewalProduct = localStorage.getItem('fromWlRenewalLink') === 'true'
        ? localStorage.getItem('wlRenewalProductKey')
        : null;

    localStorage.removeItem('fromPromo49Page');
    localStorage.removeItem('fromPromo99Page');
    localStorage.removeItem('fromUpsellPage');
    localStorage.removeItem('discountedPrice');
    localStorage.removeItem('fromWlRenewalLink');
    localStorage.removeItem('wlRenewalPrice');
    localStorage.removeItem('wlRenewalProductKey');

    try {
        document.cookie = 'brx_from_p49=;path=/;max-age=0';
        document.cookie = 'brx_from_p99=;path=/;max-age=0';
        document.cookie = 'brx_from_upsell=;path=/;max-age=0';
    } catch (e) {}

    if (productIdStorageKey === 'weightProductId') {
        if (button.hasAttribute('data-promo-49')) {
            localStorage.setItem('fromPromo49Page', 'true');
            try {
                document.cookie = 'brx_from_p49=1;path=/;max-age=172800;SameSite=Lax';
            } catch (e) {}
        }

        if (button.hasAttribute('data-promo-99')) {
            localStorage.setItem('fromPromo99Page', 'true');
            try {
                document.cookie = 'brx_from_p99=1;path=/;max-age=172800;SameSite=Lax';
            } catch (e) {}
        }

        if (button.hasAttribute('data-from-upsell')) {
            localStorage.setItem('fromUpsellPage', 'true');
            localStorage.setItem('showOrderMessage', 'true');
            try {
                document.cookie = 'brx_from_upsell=1;path=/;max-age=172800;SameSite=Lax';
            } catch (e) {}
        }

        if (button.hasAttribute('data-discounted-price')) {
            localStorage.setItem('discountedPrice', button.getAttribute('data-discounted-price'));
        } else if (fromBestSellerWlPromo && bestSellerDiscountedPrice) {
            localStorage.setItem('discountedPrice', bestSellerDiscountedPrice);
            localStorage.removeItem('fromBestSellerWlPromo');
        } else if (button.hasAttribute('data-wl-renewal-price')) {
            localStorage.setItem('wlRenewalPrice', button.getAttribute('data-wl-renewal-price'));
            localStorage.setItem('wlRenewalProductKey', button.getAttribute('data-wl-renewal-product') || '');
            localStorage.setItem('fromWlRenewalLink', 'true');
        } else if (preservedWlRenewalPrice) {
            localStorage.setItem('wlRenewalPrice', preservedWlRenewalPrice);
            localStorage.setItem('wlRenewalProductKey', preservedWlRenewalProduct || '');
            localStorage.setItem('fromWlRenewalLink', 'true');
        }

        url = '/questions-weight';

        localStorage.removeItem('questionsWeightFormData');
        localStorage.setItem('productType', 'weight');
    } else if (productIdStorageKey === 'sleepProductId') {
        url = '/questions-sleep';
        localStorage.removeItem('questionsSleepFormData');
        localStorage.removeItem('questionsFormData');
        localStorage.setItem('productType', 'sleep');
    } else if (productIdStorageKey === 'tadalafilProductId') {
        url = '/questions-tadalafil';
        localStorage.removeItem('questionsTadalafilFormData');
        localStorage.removeItem('questionsFormData');
        localStorage.setItem('productType', 'tadalafil');
    } else if (productIdStorageKey === 'sildenafilProductId') {
        url = '/questions-sildenafil';
        localStorage.removeItem('questionsSildenafilFormData');
        localStorage.removeItem('questionsFormData');
        localStorage.setItem('productType', 'sildenafil');
    } else if (productIdStorageKey === 'sermorelinProductId') {
        url = '/questions-sermorelin';
        localStorage.removeItem('questionsHormonesFormData');
        localStorage.removeItem('questionsFormData');
        localStorage.setItem('productType', 'hrt');
    } else if (productIdStorageKey === 'b12ProductId') {
        url = '/questions-b12';
        localStorage.removeItem('questionsB12FormData');
        localStorage.setItem('productType', 'b12');
    } else if (productIdStorageKey === 'nadProductId') {
        url = '/questions-nad';
        localStorage.removeItem('questionsNadFormData');
        localStorage.setItem('productType', 'nad');
    } else if (productIdStorageKey === 'retinAProductId') {
        url = '/questions-retin-a';
        localStorage.removeItem('questionsRetinAFormData');
        localStorage.setItem('productType', 'retin-a');
    } else if (productIdStorageKey === 'latisseProductId') {
        url = '/questions-latisse';
        localStorage.removeItem('questionsLatisseFormData');
        localStorage.setItem('productType', 'latisse');
    } else if (productIdStorageKey === 'hairLossProductId') {
        url = '/questions-hair-loss';
        localStorage.removeItem('questionsHairLossFormData');
        localStorage.setItem('productType', 'hair-loss');
    } else if (productIdStorageKey === 'spironolactoneProductId') {
        url = '/questions-spironolactone';
        localStorage.removeItem('questionsSpironolactoneFormData');
        localStorage.setItem('productType', 'spironolactone');
    } else if (productIdStorageKey === 'doxycyclineProductId') {
        url = '/questions-doxycycline';
        localStorage.removeItem('questionsDoxycyclineFormData');
        localStorage.setItem('productType', 'doxycycline');
    } else if (productIdStorageKey === 'peptidesProductId') {
        url = '/questions-peptides';
        localStorage.removeItem('questionsPeptidesFormData');
        localStorage.setItem('productType', 'peptides');
    } else if (productIdStorageKey === 'mensTrtProductId') {
        url = '/questions-mens-trt/?product=' + encodeURIComponent(productId);
        localStorage.removeItem('questionsMensTrtFormData');
        localStorage.setItem('productType', 'mens-trt');
    } else {
        url = '/questions';
        localStorage.removeItem('questionsFormData');
        localStorage.setItem('productType', 'mental_health');
    }

    // The weight-loss offer hides the voucher only for that checkout. Any other
    // product click must clear it, or later billing pages keep the field hidden.
    if (productIdStorageKey === 'weightProductId' && shouldExcludeVoucher) {
        localStorage.setItem('excludeVoucher', 'true');
    } else {
        localStorage.removeItem('excludeVoucher');
    }

    window.location.href = url;
});

let reviewElements = document.querySelectorAll('.reviews-carousel.splide')
let relatedSlider = document.querySelector('.relatedProducts__inner.brx-splide')
let prodSlider = document.querySelector('.homeProductsWrapper__row.brx-splide')

let speed = null

if($(window).width() > 768) {
    speed = 0.8
}else {
    speed = 1
}

if(relatedSlider) {
    new Splide(relatedSlider, {
        type: 'loop',
        arrows: false,
        autoWidth: true,
        perPage: 4,
        pagination: false,
        autoScroll: {
            speed
        },
        mediaQuery: 'max',
        breakpoints:{
            768:{
                destroy:true
            }
        }
    }).mount({ AutoScroll });
}
if(prodSlider) {
    new Splide(prodSlider, {
        type: 'slide',
        arrows: false,
        autoWidth: false,
        perPage: 3,
        pagination: false,
        autoScroll:false,
        mediaQuery: 'max',
        breakpoints:{
            992:{
                perPage: 2,
            },
            768:{
                destroy:true
            }
        }
    }).mount({ AutoScroll });
}

if(reviewElements) {
    Array.from(reviewElements).forEach(reviewElement => {
        new Splide(reviewElement, {
            type: 'slide',
            arrows: false,
            autoWidth: true,
            perPage: 4,
            pagination: false,
            autoScroll: false,
            mediaQuery: 'max',
            breakpoints:{
                768:{
                    destroy:true
                }
            }
        }).mount({ AutoScroll });
    })
}

$(function() {

    function rafThrottle(fn) {
        let ticking = false;
        return function throttled() {
            if (ticking) return;
            ticking = true;
            window.requestAnimationFrame(function() {
                fn();
                ticking = false;
            });
        };
    }

    $('.reviewSlide').each(function(item, idx) {
        $(this).css('width', $(this).find('.slideItem').length * ($(this).find('.slideItem:nth-child(1)').outerWidth() + 20) + 'px')
    })

    $('.homeCenterWrapper__blocks__item__image').on('click', function() {
        let vidSrc = $(this).attr('data-video')
        if(vidSrc) {
            $('.siteOverlay').first().fadeIn()
            const $popup = $('.videoPopupWrapper').first()
            $popup.fadeIn().find('video').attr('src', vidSrc)
            $popup.find('video')[0].play()
        }
    })

    const videoElementsNode = $('.homeCenterWrapper__blocks__item__image video');

    const videoElements = Array.from(videoElementsNode);

    videoElements.forEach(video => {
        video.playbackRate = 1.25;
    });

    const homeCenterElement = $('.homeCenterWrapper');
    const homeCenterItems = $('.homeCenterWrapper__blocks__item');
    const animatedTextEl = $('.text--animated');

    function homeCenterBlockInView(rect, vh) {
        const enterLine = vh * ($(window).width() > 992 ? 0.9 : 0.92);
        const exitTop = Math.min(140, vh * 0.18);
        return rect.top < enterLine && rect.bottom > exitTop;
    }

    function updateHomeCenterBlocks() {
        if (!homeCenterItems.length) return;
        homeCenterItems.each(function() {
            const el = this;
            const rect = el.getBoundingClientRect();
            const vh = window.innerHeight || document.documentElement.clientHeight;
            const fullH = el.scrollHeight;
            if (homeCenterBlockInView(rect, vh)) {
                $(el).addClass('active').height(fullH);
            } else {
                $(el).removeClass('active').height(90);
            }
        });
    }

    function initHomeCenterAnimatedText() {
        if (!animatedTextEl.length || !homeCenterElement.length) return;
        const blocks = homeCenterElement.find('.homeCenterWrapper__blocks');
        const trigger =
          blocks.find('.homeCenterWrapper__blocks__item:nth-child(3)')[0] ||
          blocks.find('.homeCenterWrapper__blocks__item:last-child')[0] ||
          homeCenterElement[0];

        const reveal = function() {
            animatedTextEl.stop(true, true).fadeIn(350);
        };

        if (!trigger || window.matchMedia('(max-width: 992px)').matches) {
            return;
        }

        if (typeof IntersectionObserver !== 'undefined') {
            const io = new IntersectionObserver(function(entries) {
                entries.forEach(function(entry) {
                    if (entry.isIntersecting) reveal();
                });
            }, { root: null, rootMargin: '0px 0px 0px 0px', threshold: 0.2 });
            io.observe(trigger);
        } else {
            $(window).on('scroll', rafThrottle(function() {
                const r = trigger.getBoundingClientRect();
                const vh = window.innerHeight || document.documentElement.clientHeight;
                if (r.top < vh && r.bottom > 0) reveal();
            }));
        }
    }

    $(window).on('load', function() {
        if (homeCenterElement.length === 0) return;
        initHomeCenterAnimatedText();
        updateHomeCenterBlocks();
        $(window).on('scroll', rafThrottle(updateHomeCenterBlocks));
        $(window).on('resize', rafThrottle(updateHomeCenterBlocks));
    });

    $('.videoSlider__carousel__item').on('click', function (evt) {
        let vidSrc = $(this).attr('data-src')
        if (!vidSrc) return
        $('.siteOverlay').first().fadeIn()
        const $popup = $('.videoPopupWrapper').first()
        $popup.fadeIn().find('video').attr('src', vidSrc)
        $popup.find('video')[0].play()
    })

    $('.videoPopupWrapper__close').on('click', function() {
        $('.videoPopupWrapper video').each(function () { this.pause(); $(this).attr('src', '') })
        $('.siteOverlay').fadeOut()
        $('.videoPopupWrapper').fadeOut()
    })

    $('.form-group input').on('focusin', function (e) {
        $(this).parents('.form-group').addClass('active')
    })
    $('.form-group input').on('focusout', function (e) {
        if (!this.value) {
            $(this).parents('.form-group').removeClass('active')
        }
    })

    conditioner('body');

    // Date Masking
    Inputmask({"mask": "99/99/9999"}).mask("#date");

    $(".heroVideo__soundBtn").click( function () {
        if( $(".heroVideo video").prop('muted') ) {
            $(".heroVideo video").prop('muted', false);
            $(".heroVideo__soundBtn").addClass('active')
        } else {
            $(".heroVideo video").prop('muted', true);
            $(".heroVideo__soundBtn").removeClass('active')
        }
    });

    if($(window).width() < 768) {
        $('.heroVideo video').on('loadeddata', function() {
            setTimeout(function() {
                $('.heroVideo img').fadeOut();
                $('.heroVideo video').show();
                $('.heroVideo__soundBtn').show()
                $('.heroVideo').css('height', 'auto')
                if($('.heroVideo__words').length > 0) {
                    $('.heroVideo__words').remove();
                }
            }, 150)
        });
        let i = 0
        $('.heroVideo__words span i').eq(0).addClass('active')
        $('.heroVideo__words span').css('width', $('.heroVideo__words span i').eq(0).width() + 'px')
        setInterval(function() {
            $('.heroVideo__words span i').removeClass('active')
            $('.heroVideo__words span i').eq(i).addClass('active')
            i++
            if(i > $('.heroVideo__words span i').length - 1) {
                i = 0
            }
            let currentWidth = $('.heroVideo__words span i.active').width()
            $('.heroVideo__words span').css('width', currentWidth + 'px')
        }, 2000)
        let companySlider = document.querySelector('.companies-mobile')
        if(companySlider !== null) {
            const comSliderFlickity = new Flickity(companySlider, {
                cellAlign: 'left',
                contain: false,
                autoPlay:4000,
                prevNextButtons:false,
                pageDots:false,
                pauseAutoPlayOnHover:false,
                draggable: true,
                contain:true,
                wrapAround: true,
                on: {
                    ready: function() {
                        document.querySelector('.companies-wrapper').style.display = 'none'
                        document.querySelector('.companies-wrapper-mobile').style.opacity = 1
                    }
                }
            })
        }
    }else {
        $('.heroVideo video').on('loadeddata', function() {
            $('.heroVideo img').fadeOut();
            $('.heroVideo video').show();
            $('.heroVideo__soundBtn').show()
        });
    }

    const isSleepPage = window.location.pathname === '/sleep' || window.location.pathname.startsWith('/sleep/');
    const headerTarget = isSleepPage ? $('header.primary') : $('header.home');
    const sleepNavLinks = $('nav.primary a');
    const sleepHeroOffsetTop = $('.brx_hero').length ? $('.brx_hero').offset().top : 0;
    const headerFixedScrollThreshold = isSleepPage && $('.brx_hero').length
      ? Math.max(sleepHeroOffsetTop - 150, 100)
      : 100;

    const toggleHomeHeaderFixed = function() {
        if ($(window).scrollTop() > headerFixedScrollThreshold) {
            headerTarget.addClass('header-fixed');
            if (isSleepPage) {
                sleepNavLinks.removeClass('sleep-nav-white');
            }
        } else {
            headerTarget.removeClass('header-fixed');
            if (isSleepPage) {
                sleepNavLinks.addClass('sleep-nav-white');
            }
        }
    };

    toggleHomeHeaderFixed();

    // Sticky Header
    $(window).scroll(function(){
        toggleHomeHeaderFixed();
        let videoHeight = $('.heroVideo').height() / 2

        if($(this).scrollTop() > videoHeight) {
            $('.heroVideo video').trigger('pause');
        } else {
            $('.heroVideo video').trigger('play');
        }
    });

    // Sticky Header
    $(window).scroll(function(){
        toggleHomeHeaderFixed();
    });
    if($(window).width() > 767) {
        $('.brxAccordeon__item').first().find('.accordHidden').slideDown()
        $('.brxAccordeon__item').first().find('h3').addClass('active')
    }else {
        if($('.brx_hero__content').length !== 0) {
            $(window).scroll(function(){
                if($(window).scrollTop() > $('.brx_hero__content').offset().top - 150) {
                    $('.brxAccordeon__item').first().find('.accordHidden').slideDown()
                    $('.brxAccordeon__item').first().find('h3').addClass('active')
                }
            });
        }
    }
    $('.brxAccordeon__item h3').on('click', function() {
        $('.accordHidden').stop().slideUp()
        $('.brxAccordeon__item h3').removeClass('active')
        if($(this).next().is(':visible')) {
            $(this).next().stop().slideUp()
            $(this).removeClass('active')
        }else {
            $(this).next().stop().slideToggle()
            $(this).toggleClass('active')
        }
    })

    // ----------------------
    // Main navigation
    var body            = $('body'),
      navIcon         = $('.nav-icon'),
      navContainer    = $('.menu'),
      navPrimary      = $('nav.primary');


    navIcon.on('click', function() {
        navContainer.toggleClass('menu-active');
        navIcon.toggleClass('nav-icon--active');
        navPrimary.toggleClass('nav-active');
    });

    // Submenu nav
    var hasDropdown = $('.has-dropdown > a');

    hasDropdown.on('click', function(e) {
        if ($(window).width() < 960) {
            e.preventDefault();
        }
        var $parentLi = $(this).closest('li');
        $parentLi.toggleClass('has-dropdown--active');
        $parentLi.find('.dropdown-menu').toggleClass('dropdown-menu--active');
    });


    // ----------------------
    // Team member area
    var teamMemberArea 		= $('.team-profile-trigger, .team-member--image'),
        teamMemberInfo		= $('.team-member--info'),
        teamProfileTrigger	= $('.team-profile-trigger'),
        teamMemberBio		= $('.team-member--bio');

    $.fn.slideFadeToggle = function(speed, easing, callback) {
        return
        this.animate({
                opacity: 'toggle',
                height: 'toggle'
            },
            speed,
            easing,
            callback
        );
    }

    teamMemberArea.each(function() {
        $(this).on('click', function() {
            if ($(this).hasClass('team-member--image')) {
                $(this).siblings('.team-member--info').children('.team-member--bio').fadeToggle();
                $(this).siblings('.team-member--info').children('.team-profile-trigger').toggleClass('team-profile-trigger--text');
            } else if ($(this).hasClass('team-profile-trigger')) {
                $(this).siblings('.team-member--bio').fadeToggle();
                $(this).toggleClass('team-profile-trigger--text');
            }
        });
    });

    // Accordion
    var $accordion = $('.accordion');

    $accordion.accordion({
        hiddenOnLoad: true,
        singleOpen: true
    });


    // Alert
    var stopAutorefillForm = $('form[name=autorefill-form]'),
      reorderForm = $('form[name=reorder-form]');

    stopAutorefillForm.on('submit', function(e) {
        e.preventDefault();
        var form = this;
        swal("Are you sure you want to stop autorefill for this prescription?", {
            buttons: {
                cancel: "No",
                confirm: "Yes, stop autorefill"
            }
        }).then((value) => {
            if (value) {
                form.submit();
                return true;
            } else {
                return false;
            }
        });
    });

    reorderForm.on('submit', function(e) {
        e.preventDefault();
        var form = this;
        swal("Are you sure you want to reorder this product?", {
            buttons: {
                cancel: "No",
                confirm: "Yes, submit order"
            }
        }).then((value) => {
            if (value) {
                form.submit();
                return true;
            } else {
                return false;
            }
        });
    });

    if ($('.contentWrapper').hasClass('subOutPrices')) {
        $('.pricing').hide();
        $('.cta-with-price__price').hide();
        $('.cta-with-price__price.-groupon-price').show();
        $('.cta-with-price__price.-groupon-price').addClass('-crossed-out');
        $('.cta-with-price__price.-groupon-price').after(`
<div class="first-shipment-free">
<ul>
        <li>FREE order</li>
        <li>Includes 24 Hour Shipping</li>
        <li>Cancel anytime - no commitment</li>
        <li>Refills are offered at the lowest price of any major US telehealth company</li>
</ul>
</div>
        `)
        $('.cta-with-price__price.-groupon-price').after('<div class="cta-with-price__free">$0.00</div>')
        $('.cta-with-price__cta').append(' FREE')

        $('.priceComparison__priceGroup.-us .priceGroup__price').addClass('-crossed-out')
        $('.priceComparison__priceGroup.-us').append('<div class="priceGroup__price -free">$0.00</div><div class="priceGroup__type">(FREE order - no commitment)</div>')
    }

    function normalizeVisitorStateForUi() {
        let s = (localStorage.getItem('state') || '').trim().toLowerCase();
        if (typeof window.__VISITOR_STATE_NORMALIZED__ === 'string' && window.__VISITOR_STATE_NORMALIZED__ !== '') {
            s = window.__VISITOR_STATE_NORMALIZED__;
        }
        if (s === 'in') {
            s = 'indiana';
        }
        return s;
    }

    function applyStateUI(nextState) {
        const state = nextState !== undefined && nextState !== null && nextState !== ''
          ? (String(nextState).trim().toLowerCase() === 'in' ? 'indiana' : String(nextState).trim().toLowerCase())
          : normalizeVisitorStateForUi();
        const isIndiana = state === 'indiana' || state === 'in';
        const url = window.location.pathname.toLowerCase();
        const glpNavLinks = document.querySelectorAll('a[href*="/semaglutide-and-tirzepatide"]');
        const heroGlpLinks = document.querySelectorAll('.left-side-content, [data-hero-link][href*="/semaglutide-and-tirzepatide"]');

        glpNavLinks.forEach(function(link) {
            const listItem = link.closest('li');
            if (listItem) {
                listItem.style.display = isIndiana ? 'none' : '';
            }
        });

        heroGlpLinks.forEach(function(link) {
            link.style.display = isIndiana ? 'none' : '';
        });

        if (
          isIndiana &&
          (url.includes('semaglutide-and-tirzepatide') || url.includes('weightloss') || url.includes('questions-weight'))
        ) {
            window.location.href = '/';
        }

        if (isIndiana) {
            document.querySelectorAll('.hero-navigation-item').forEach(item => {
                const title = item.dataset.title;

                if (title.includes('weight')) {
                    item.style.display = 'none';
                }
            });

            document.querySelectorAll('.weight-loss-product').forEach(function (el) {
                el.style.display = 'none';
            });

            document.querySelectorAll('.upsellProductsWrapper').forEach(function (el) {
                el.style.display = 'none';
            });
            document.querySelectorAll('.upsell-heading').forEach(function (el) {
                el.style.display = 'none';
            });
        }
    }

    applyStateUI();

    window.__flushVisitorRegionPending = function () {
        const pending = window.__VISITOR_REGION_PENDING;
        if (!pending) {
            return;
        }
        window.__VISITOR_REGION_PENDING = null;
        const st = pending.state !== undefined && pending.state !== null ? pending.state : undefined;
        applyStateUI(st);
    };
    window.__flushVisitorRegionPending();

    const serverResolved = typeof window.__VISITOR_STATE_SOURCE__ === 'string' && window.__VISITOR_STATE_SOURCE__ !== '';
    const headWillFetch = typeof window.__VISITOR_REGION_HEAD_FETCH__ !== 'undefined' && window.__VISITOR_REGION_HEAD_FETCH__;
    if (!serverResolved && !headWillFetch) {
        fetch('/api/v1/visitor-region', { credentials: 'same-origin' })
          .then(function(res) {
              if (!res.ok) {
                  throw new Error('visitor-region failed');
              }
              return res.json();
          })
          .then(function(body) {
              const d = body.data || {};
              const state = (d.state || '').trim();
              if (state) {
                  localStorage.setItem('state', state);
              }
              return state;
          })
          .then(function(state) {
              applyStateUI(state);
          })
          .catch(function() {
              fetch('https://ipapi.co/json/')
                .then(function(res) {
                    if (!res.ok) {
                        throw new Error('Failed geolocation request');
                    }
                    return res.json();
                })
                .then(function(data) {
                    const state = (data.region || '').trim();
                    if (state) {
                        localStorage.setItem('state', state);
                    }
                    return state;
                })
                .then(function(state) {
                    applyStateUI(state);
                })
                .catch(function() {
                    applyStateUI();
                });
          });
    }

    // Phone search functionality with custom dropdown
    const phoneSearch = document.getElementById('phoneSearch');
    const phoneDropdown = document.getElementById('phoneDropdown');
    const phoneData = document.getElementById('phoneData');

    if (phoneSearch && phoneDropdown && phoneData) {
        // Get phone numbers from the data attribute
        let phoneNumbers = [];
        try {
            const rawPhones = JSON.parse(phoneData.dataset.phones || '[]');
            phoneNumbers = rawPhones.map(phone => ({
                value: phone,
                display: formatPhoneNumber(phone)
            }));
        } catch (e) {
            console.error('Error parsing phone data:', e);
        }

        // Format phone number for display
        function formatPhoneNumber(phone) {
            if (phone.length === 10) {
                return `(${phone.slice(0,3)}) ${phone.slice(3,6)}-${phone.slice(6)}`;
            }
            return phone;
        }

        // Function to show matching phone numbers in the dropdown
        function showMatchingPhones(searchTerm) {
            // Clear previous results
            phoneDropdown.innerHTML = '';

            if (!searchTerm) {
                phoneDropdown.style.display = 'none';
                return;
            }

            searchTerm = searchTerm.toLowerCase();
            let matchFound = false;

            // Find and display matching phone numbers
            phoneNumbers.forEach(phone => {
                if (phone.value.includes(searchTerm) ||
                  phone.display.toLowerCase().includes(searchTerm)) {

                    const item = document.createElement('div');
                    item.className = 'dropdown-item';
                    item.textContent = phone.display;
                    item.dataset.value = phone.value;

                    item.addEventListener('click', function() {
                        phoneSearch.value = phone.value;
                        phoneDropdown.style.display = 'none';
                    });

                    phoneDropdown.appendChild(item);
                    matchFound = true;
                }
            });

            // Show "No results" if no matches found
            if (!matchFound) {
                const noResults = document.createElement('div');
                noResults.className = 'dropdown-item no-results';
                noResults.textContent = 'No results found';
                phoneDropdown.appendChild(noResults);
            }

            // Show the dropdown
            phoneDropdown.style.display = 'block';
        }

        // Event listener for input changes
        phoneSearch.addEventListener('input', function() {
            showMatchingPhones(this.value);
        });

        // Close dropdown when clicking outside
        document.addEventListener('click', function(e) {
            if (e.target !== phoneSearch && !phoneDropdown.contains(e.target)) {
                phoneDropdown.style.display = 'none';
            }
        });

        // Show dropdown when focusing on the input
        phoneSearch.addEventListener('focus', function() {
            if (this.value) {
                showMatchingPhones(this.value);
            }
        });
    }
});

/**
 * Start the auto logout timer if in the dashboard
 */
if( $('body').hasClass('portal-body') ) {
    // Auto-logoout Timer
    var minutesIdle = 0;
    var idleChecker = function() {
        minutesIdle += 1;

        if(minutesIdle >= 5) {
            showLogoutPopup();
        }

        $('body').on('mousemove keyup', () => minutesIdle = 0);
    };
    var showLogoutPopup = function() {
        var logoutTimeout = setTimeout(() => {
            window.location.replace('/dashboard/logout')
        }, 60000);

        clearInterval(idleTimer);
        swal("You will be logged out in 1 minute due to inactivity. Click the button below to remain logged in", {
            buttons: {
                confirm: "Stay Logged In"
            }
        }).then( () => {
            clearTimeout(logoutTimeout);
            var idleTimer = setInterval(idleChecker, 840000);
        } );

    }
    var idleTimer = setInterval(idleChecker, 840000);
}

// add visible class on scroll when element is visible
(function() {
    const videoSlider = document.querySelector('.videoSlider__carousel')
    function initializeFlickity() {
        const initialIndex = parseInt(videoSlider.getAttribute('data-initial-index'), 10) || 0;
        const videoSliderFlickity = new Flickity(videoSlider, {
            contain: true,
            cellAlign: 'center',
            percentPosition: false,
            selectedAttraction: 0.005,
            freeScroll: false,
            arrowShape: 'M100,43.8H23.9L58.9,8.8L50,0L0,50l50,50l8.8-8.8L23.9,56.2H100V43.8z',
            draggable: true,
            initialIndex: initialIndex,
        });

        let isDragging = false;
        const dragStart = (e) => {
            if (isDragging) return;
            videoSliderFlickity.slider.childNodes.forEach(slide => slide.style.pointerEvents = "none")
            isDragging = true;
        }

        const dragEnd = (e) => {
            if (!isDragging) return;
            videoSliderFlickity.slider.childNodes.forEach(slide => slide.style.pointerEvents = "all")
            isDragging = false
        }

        // touchmove and touchend for iOS bug
        videoSliderFlickity.slider.addEventListener('touchmove', dragStart);
        videoSliderFlickity.slider.addEventListener('touchend', dragEnd);
        videoSliderFlickity.on('dragStart', dragStart);
        videoSliderFlickity.on('dragEnd', dragEnd);
    }

    document.addEventListener('DOMContentLoaded', function () {
        $('.form-group input').each(function() {
            if (!this.value) {
                $(this).parents('.form-group').removeClass('active')
            }else {
                $(this).parents('.form-group').addClass('active')
            }
        })
        if(videoSlider) {
            initializeFlickity()
        }
    });

    window.onresize = function() {
        if(videoSlider) {
            initializeFlickity()
        }
    }
    const elements = document.querySelectorAll('.redactor-circle, .redactor-underline');
    function isInViewport(element, offset = 0) {
        const rect = element.getBoundingClientRect();
        return (
          rect.top + offset >= 0 &&
          rect.left + offset >= 0 &&
          rect.bottom + offset <= (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right + offset <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    function addActiveClass() {
        window.requestAnimationFrame(() => {
            let delay = 500
            let visibleEls = Array.from(elements).filter(el => !el.classList.contains('visible') && isInViewport(el, 150));
            for(let i = 0; i < visibleEls.length; i++) {
                let newDelay = delay + i * 500
                setTimeout(() => {
                    visibleEls[i].classList.add(`visible`);
                }, newDelay)
            }
        });
    }
    addActiveClass();
    window.addEventListener('scroll', addActiveClass);
})();

// Ticker Photos Carousel
(function() {
    // ticker speed
    let tickerSpeed = 0.35;

    const slideshowElements = document.querySelectorAll('.ticker-photos__container.flickity-ticker, .ticker-photos-small__container.flickity-ticker');

    slideshowElements.forEach(slideshowEl => {
        let flickity = null;
        let isPaused = false;

        const update = () => {
            if(isPaused) {
                return
            }else {
                if (flickity.slides) {
                    flickity.x = (flickity.x - tickerSpeed) % flickity.slideableWidth;
                    flickity.selectedIndex = flickity.dragEndRestingSelect();
                    flickity.updateSelectedSlide();
                    flickity.settle(flickity.x);
                }
            }
            window.requestAnimationFrame(update);
        };

        const pause = () => {
            isPaused = true;
        };

        const play = () => {
            if (isPaused) {
                isPaused = false;
                window.requestAnimationFrame(update);
            }
        };

        flickity = new Flickity(slideshowEl, {
            autoPlay: false,
            freeScroll: true,
            prevNextButtons: false,
            pageDots: false,
            contain: true,
            cellAlign: 'center',
            draggable: true,
            wrapAround: true,
            selectedAttraction: 0.015,
            friction: 0.25,
        });
        flickity.x = 0;

        // slideshowEl.addEventListener('mouseenter', pause, false);
        // slideshowEl.addEventListener('focusin', pause, false);
        // slideshowEl.addEventListener('mouseleave', play, false);
        // slideshowEl.addEventListener('focusout', play, false);

        flickity.on('dragStart', () => {
            isPaused = true;
        });
        flickity.on('dragEnd', () => {
            isPaused = false
            setTimeout(() => {
                update()
            }, 2500)
        });

        update();
    })
})();

// Before After Carousels
(function() {
    let beforeSlider1 = document.querySelector('#beforeSlider'),
      beforeSlider2 = document.querySelector('#slideWithInfo'),
      companySlider = document.querySelector('.companies-mobile')

    let flickity1 = null;
    let flickity2 = null;

    if (beforeSlider1) {
        flickity1 = new Flickity(beforeSlider1, {
            fade: true,
            autoPlay: 5000,
            prevNextButtons: false,
            dots: false,
            pauseAutoPlayOnHover: false,
            draggable: false,
            on: {
                select: function(index) {
                    if (index !== 0) {
                        //$('.before-after-slider__words').addClass('goLeft')
                    } else {
                        //$('.before-after-slider__words').removeClass('goLeft')
                    }
                    $('.before-after-slider .progress-slider-bar span').
                    removeClass('active')
                    $('.before-after-slider .progress-slider-bar span').
                    eq(index).
                    addClass('active')
                },
            }
        });
    }

    if (beforeSlider2) {
        flickity2 = new Flickity(beforeSlider2, {
            fade: true,
            autoPlay: 5000,
            prevNextButtons: false,
            dots: false,
            pauseAutoPlayOnHover: false,
            draggable: false,
            on: {
                select: function(index) {
                    $('.expert-derm-team__wrapper .progress-slider-bar span').
                    removeClass('active')
                    $('.expert-derm-team__wrapper .progress-slider-bar span').
                    eq(index).
                    addClass('active')
                    window.requestAnimationFrame(() => {
                        let delay = 500
                        let visibleEls = document.querySelectorAll(
                          '.before-after-slider__words span')
                        for (let i = 0; i < visibleEls.length; i++) {
                            let newDelay = delay + i * 500
                            setTimeout(() => {
                                visibleEls[i].classList.remove('hiddens');
                                visibleEls[i].classList.add('visible', 'again');
                            }, newDelay)
                        }
                    });
                },
                settle: function(index) {
                    let visibleEls = document.querySelectorAll(
                      '.before-after-slider__words span')
                    for (let i = 0; i < visibleEls.length; i++) {
                        visibleEls[i].classList.remove('visible', 'again');
                        visibleEls[i].classList.add('hiddens');
                    }
                }
            }
        });
    }


    if(window.innerWidth < 768 ) {
        document.addEventListener('DOMContentLoaded', function () {
            if(companySlider !== null) {
                const comSliderFlickity = new Flickity(companySlider, {
                    cellAlign: 'left',
                    contain: false,
                    autoPlay:4000,
                    prevNextButtons:false,
                    pageDots:false,
                    pauseAutoPlayOnHover:false,
                    draggable: true,
                    contain:true,
                    wrapAround: true,
                    on: {
                        ready: function() {
                            document.querySelector('.companies-wrapper').style.display = 'none'
                            document.querySelector('.companies-wrapper-mobile').style.opacity = 1
                        }
                    }
                })
            }
        })
    }

    $('.videoSlider__carousel__item').on('click', function() {
        let vidSrc = $(this).attr('data-src')
        if (!vidSrc) return
        $('.siteOverlay').first().fadeIn()
        const $popup = $('.videoPopupWrapper').first()
        $popup.fadeIn().find('video').attr('src', vidSrc)
        $popup.find('video')[0].play()
    })

    $('.videoPopupWrapper__close').on('click', function() {
        $('.videoPopupWrapper video').each(function () { this.pause(); $(this).attr('src', '') })
        $('.siteOverlay').fadeOut()
        $('.videoPopupWrapper').fadeOut()
    })

    $('.expert-slider-info__item').first().addClass('active')
    $('.expert-slider-info').height($('.expert-slider-info__item').first().outerHeight())
    if (flickity2 !== null) {
        flickity2.on( 'select', function(currentIndex) {
            $('.expert-slider-info__item').removeClass('active')
            $('.expert-slider-info__item').eq(currentIndex).addClass('active')
            $('.expert-slider-info').height($('.expert-slider-info__item').eq(currentIndex).outerHeight())
        });
    }

    $('.before-after-carousel .play--button').on('click', function() {
        $('.before-after-carousel__item__video video').get(0).pause()
        $('.before-after-carousel__item__video').hide()
        $('.before-after-carousel__item__preview').show()
        $('.play--button').show()
        $(this).hide()
        $(this).parent().find('.before-after-carousel__item__preview').hide()
        $(this).parent().find('.before-after-carousel__item__video').show()
        $(this).parent().find('.before-after-carousel__item__video video').get(0).play()
    })

    // main carousel
    document.querySelectorAll('.before-after-carousel__carousel').forEach(carousel => {
        const flickity = new Flickity(carousel, {
            contain: true,
            cellAlign: 'center',
            keyboard:true,
            percentPosition: false,
            selectedAttraction: 0.005,
            freeScroll: true,
            arrowShape: 'M100,43.8H23.9L58.9,8.8L50,0L0,50l50,50l8.8-8.8L23.9,56.2H100V43.8z'
        });
    });

    const reviewCarousel = document.querySelector('.reviews-carousel')
    const videoSlider = document.querySelector('.videoSlider__carousel')
    const productSlider = document.querySelector('.showColumnsMobile__slider')

    if (productSlider) {
        const productSliderFlickity = new Flickity(productSlider, {
            contain: true,
            cellAlign: 'center',
            percentPosition: false,
            selectedAttraction: 0.01,
            freeScroll: false,
            arrowShape: 'M100,43.8H23.9L58.9,8.8L50,0L0,50l50,50l8.8-8.8L23.9,56.2H100V43.8z',
            draggable: true,
            pageDots:false
        })
          .on('change', function(index) {
              $('.showColumnsMobile__button').removeClass('active')
              $('.showColumnsMobile__button').eq(index).addClass('active')
          })

        $('.showColumnsMobile__button').each(function(idx, item) {
            $(item).on('click', function() {
                $('.showColumnsMobile__button').removeClass('active')
                $(this).addClass('active')
                productSliderFlickity.select(idx)
            })
        })
    }

    function initializeFlickity() {
        var initialIndex = parseInt(videoSlider.getAttribute('data-initial-index'), 10) || 0;
        var options = {
            contain: true,
            cellAlign: 'center',
            percentPosition: false,
            selectedAttraction: 0.005,
            freeScroll: false,
            arrowShape: 'M100,43.8H23.9L58.9,8.8L50,0L0,50l50,50l8.8-8.8L23.9,56.2H100V43.8z',
            draggable: true,
            initialIndex: initialIndex,
        };

        const videoSliderFlickity = new Flickity(videoSlider, options);
        let isDragging = false;
        const dragStart = (e) => {
            if (isDragging) return;
            videoSliderFlickity.slider.childNodes.forEach(slide => slide.style.pointerEvents = "none")
            isDragging = true;
        }

        const dragEnd = (e) => {
            if (!isDragging) return;
            videoSliderFlickity.slider.childNodes.forEach(slide => slide.style.pointerEvents = "all")
            isDragging = false
        }
        // touchmove and touchend for iOS bug
        videoSliderFlickity.slider.addEventListener('touchmove', dragStart);
        videoSliderFlickity.slider.addEventListener('touchend', dragEnd);
        videoSliderFlickity.on('dragStart', dragStart);
        videoSliderFlickity.on('dragEnd', dragEnd);
        // videoSliderFlickity.on('dragStart', () => videoSliderFlickity.slider.childNodes.forEach(slide => slide.style.pointerEvents = "none") );
        // videoSliderFlickity.on('dragEnd', () => videoSliderFlickity.slider.childNodes.forEach(slide => slide.style.pointerEvents = "all") );
    }

    document.addEventListener('DOMContentLoaded', function () {
        if(videoSlider) {
            initializeFlickity()
        }
    });

    window.onresize = function() {
        if(videoSlider) {
            initializeFlickity()
        }
    }

    let speed = null

    if($(window).width() > 768) {
        speed = 0.5
    }else {
        speed = 1
    }

    let reviewElement = document.querySelector('.reviews-carousel.splide')

    if(reviewElement !== null) {
        new Splide(reviewElement, {
            type: 'loop',
            arrows: false,
            autoWidth: true,
            perPage:4,
            pagination: false,
            autoScroll: {
                speed,
            },
        }).mount({ AutoScroll });
    }

    // images before/after/during
    document.querySelectorAll('.before-after-carousel__images--carousel').forEach(slider => {
        const prevBtn = slider.querySelector('.before-after-carousel__images--carousel-prev'),
          nextBtn = slider.querySelector('.before-after-carousel__images--carousel-next'),
          allItems = slider.querySelectorAll('.before-after-carousel__images--carousel-item');

        allItems[0].addEventListener('click', () => buttons('prev'))
        allItems[1].addEventListener('click', () => buttons('next'))

        // make second element active by default
        if (allItems[1]) allItems[1].classList.add('active');

        const checkButtons = (itemIndex) => {
            if (itemIndex <= 0) prevBtn.classList.add('disabled');
            else prevBtn.classList.remove('disabled');

            if (itemIndex >= allItems.length -1) nextBtn.classList.add('disabled')
            else nextBtn.classList.remove('disabled')
        }

        const buttons = (dir) => {
            let activeItem = [...allItems].findIndex(el => el.classList.contains('active'));
            if (activeItem === -1) return;
            let isLast = dir === 'prev' ? activeItem === 0 : activeItem === allItems.length - 1;
            let nextIndex = dir === 'prev' ? activeItem - 1 : activeItem + 1;
            if (!isLast) {
                allItems[activeItem].classList.remove('active');
                allItems[nextIndex].classList.add('active');
                checkButtons(nextIndex)
            }
        }

        prevBtn.addEventListener('click', () => buttons('prev'))
        nextBtn.addEventListener('click', () => buttons('next'))
    })

    $('.form-group input').each(function() {
        if (!this.value) {
            $(this).parents('.form-group').removeClass('active')
        }else {
            $(this).parents('.form-group').addClass('active')
        }
    })

    $('.form-group input').on('focusin', function (e) {
        $(this).parents('.form-group').addClass('active')
    })
    $('.form-group input').on('focusout', function (e) {
        if (!this.value) {
            $(this).parents('.form-group').removeClass('active')
        }
    })
})();

// weight-loss js
(function() {
    // companies carousel
    const companiesCarousel = document.querySelector('.companies-carousel');
    if (companiesCarousel) {
        let splide = new Splide(companiesCarousel, {
            type: 'loop',
            perPage: 6,
            autoplay: false,
            interval: 3000,
            pauseOnHover: false,
            pauseOnFocus: false,
            gap: 50,
            arrows: false,
            padding: 15,
            breakpoints: {
                700: {
                    autoplay: true,
                    perPage: 3,
                    focus: 'center',
                    pagination: false,
                },
                500: {
                    focus: 'left',
                    perPage: 2,
                },
            },
        } );
        splide.mount();
    }

    // weight loss hero carousel
    const weightLossHeroCarousels = document.querySelectorAll('.weight-loss-hero__line');
    if (weightLossHeroCarousels.length) {
        Array.from(weightLossHeroCarousels).forEach(carousel => {
            const speed = parseFloat(carousel.dataset.splideSpeed || 0.5);
            const mobileSpeed = parseFloat(carousel.dataset.splideSpeedMobile || 0.5);
            const defaultDirection = carousel.dataset.splideDirection || 'ttb';
            const mobileDirection = carousel.dataset.splideDirectionMobile || 'rtl';
            const isHorizontal = defaultDirection === 'ltr' || defaultDirection === 'rtl';
            const start = parseInt(carousel.dataset.splideStart || '0', 10);

            new Splide(carousel, {
                direction: defaultDirection,
                type: 'loop',
                arrows: false,
                autoWidth: isHorizontal,
                autoHeight: !isHorizontal,
                pagination: false,
                height: isHorizontal ? null : '50vh',
                heightRatio: isHorizontal ? null : 0.5,
                start: start,
                pauseOnHover: false,
                pauseOnFocus: false,
                drag: carousel.closest('.trt-lp') ? 'free' : true,
                lazyLoad: 'nearby',
                autoScroll: {
                    speed,
                    pauseOnHover: false,
                    pauseOnFocus: false,
                },
                breakpoints: {
                    1200: {
                        height: null,
                        heightRatio: null,
                        direction: mobileDirection,
                        autoWidth: true,
                        autoScroll: {
                            speed: mobileSpeed,
                            pauseOnHover: false,
                            pauseOnFocus: false,
                        }
                    },
                },
            }).mount({ AutoScroll });
        });
    }

    const trtCarousels = document.querySelectorAll('.trt-lp [data-trt-carousel]');
    if (trtCarousels.length) {
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        Array.from(trtCarousels).forEach(carousel => {
            const splide = new Splide(carousel, {
                type: 'loop',
                direction: 'ltr',
                arrows: false,
                pagination: false,
                autoWidth: true,
                gap: carousel.dataset.trtGap || '24px',
                drag: 'free',
                flickPower: 300,
                pauseOnHover: false,
                pauseOnFocus: false,
                lazyLoad: 'nearby',
                autoScroll: {
                    speed: parseFloat(carousel.dataset.trtSpeed || 0.5),
                    pauseOnHover: false,
                    pauseOnFocus: false,
                },
            });

            prefersReducedMotion ? splide.mount() : splide.mount({ AutoScroll });
        });
    }

    // weight loss slider calculator
    const weightLossSliders = document.querySelectorAll('[data-weight-loss]');
    if (weightLossSliders.length) {
        Array.from(weightLossSliders).forEach(rangeSlider => {
            const input = rangeSlider.querySelector('[data-weight-loss-input]');
            const output = rangeSlider.querySelector('[data-weight-loss-output]');
            const goal = rangeSlider.querySelector('[data-weight-loss-goal]');
            const updateOutput = () => {
                output.textContent = input.value;
                // 20% of input value
                goal.textContent = parseInt(input.value * 0.2);
            };

            input.addEventListener('input', updateOutput);
        });
    }
})();

// add visible class on scroll when element is visible
(function() {
    const elements = document.querySelectorAll('.redactor-circle, .redactor-underline');
    function isInViewport(element, offset = 0) {
        const rect = element.getBoundingClientRect();
        return (
          rect.top + offset >= 0 &&
          rect.left + offset >= 0 &&
          rect.bottom + offset <= (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right + offset <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    function addActiveClass() {
        window.requestAnimationFrame(() => {
            let delay = 500
            let visibleEls = Array.from(elements).filter(el => !el.classList.contains('visible') && isInViewport(el, 150));
            for(let i = 0; i < visibleEls.length; i++) {
                let newDelay = delay + i * 500
                setTimeout(() => {
                    visibleEls[i].classList.add(`visible`);
                }, newDelay)
            }
        });
    }
    addActiveClass();
    window.addEventListener('scroll', addActiveClass);
})();


// WEBPACK FOOTER //
// ./resources/assets/js/site.js